
<div class="is-flex is-align-content-center is-justify-content-center is-text-center"> 
  <button class="control-button-minus flex justify-center items-center" disabled>
    <img src="@/images/quote-builder/minus.svg" alt="Minus">
  </button>
   
  <div class="order-item-quantity flex items-center justify-center">
    <p>0</p>
  </div>   
  <button class="control-button-plus flex justify-center items-center" :disabled="loading" @click="addToQuote">
    <img src="@/images/quote-builder/plus.svg" alt="Plus">
  </button>
</div>
